import { accountFragment, chatInviteFragment } from '../fragments';
import { makeRequest } from '../utils';

/**
 * @param {string} personId
 */
export const findPersonChatInvite = personId =>
  makeRequest({
    operationName: 'PersonChatInvite',
    query: `
      query PersonChatInvite($personId: String!) {
        personChatInvite(personId: $personId) {
          ...ChatInviteFragment
        }
      }
      
      ${chatInviteFragment}
      ${accountFragment}
    `,
    variables: { personId },
  });
